<template>
  <div class="form-group">
    <div class="grey mb5">{{ label ?? name }}</div>
    <input :type="type" class="form-control" :name="name" :placeholder="placeholder" v-validate="rules"
      v-model="inputValue" :disabled="disabled" />
    <small class="text-danger text-sm" v-show="errors.has(name)">
      {{ errors.first(name) }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'FieldTextInput',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    parentClass: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    }
  },
  inject: ['$validator']
};
</script>
